import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertServiceService } from 'src/app/service/alert/alert-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  appBaseUrl = environment.appBaseUrL;
  showAgentModal = false;

  constructor(
    private router: Router,
    private alert: AlertServiceService,
  ) { }

  openAgentModal() {
    this.showAgentModal = true;
    document.body.style.overflow = 'hidden';
  }

  openDevDocs() {
    window.open('https://docs.google.com/document/d/1ZYwPrnXr7mgeahGQezqG63uP0lNOLwCM8SzLLbgTYGo/edit?tab=t.0#heading=h.6xcq3fjg48li', '_blank');
  }

  navigateUrl(event: any) {
    this.router.navigate([event]);
  }

  navigate(event: any) {
    this.alert.showLoading();
    return window.location.assign(event);
  }

  ngOnInit(): void {
  }

}
